import { decodeEntities, generateBackgroundImgUrl, setStylesOnElement } from "../../util/Misc";
import Aria from "../../util/Aria";
import {disclaimerRender} from "../templates/renders/disclaimer";
import { customOutOfFocus } from "../../controller/TranscriptController";

/**
 * custom element that displays a disclaimer text
 * @type {{template, created(), tagName: string}}
 */
const DisclaimerView: any = {
    tagName: "disclaimer-view",
    initialize(options) {
        initComponent(options);
    },
    renderer: disclaimerRender,
    created() {
        this.ariaUtil = new Aria(this.$app);

        this.cont = this.el.firstChild;
        this.disclaimer = this.cont.querySelector(".disclaimer");
        setStylesOnElement(this.disclaimerStyleProps, this.cont);
        this.disText = this.disclaimer.lastElementChild;
        this.icon = this.disclaimer.firstElementChild;
    },

    /**
     *
     * @param {Message} message
     */
    render(message) {
        let messageText = message.getMessageText();

        if (messageText) {
            messageText = this.ariaUtil.injectAttributes(messageText);
            this.disText.innerHTML = decodeEntities(messageText);

            if (!this.$app.getRestoring()) {
                this.ariaUtil.announceBubbleText(messageText);
            }
        }

        if (this.disImgConfig) {
            const url = generateBackgroundImgUrl(this.disImgConfig, this.$app);

            if (url) {
                this.icon.style.backgroundImage = url;
            }

            if (this.disImgConfig.text) {
                this.icon.setAttribute("aria-label", this.disImgConfig.text);
            }

            if (url && this.disImgConfig.text) {
                this.icon.setAttribute("role", "img");
            }
        }

        customOutOfFocus(this.disclaimer, this.$app);
    },
    onItemClick(event) {
        if (event.target.tagName.toLowerCase() === "a") {
            // Agent pushed links are send to Bootstrap for top window navigation
            this.$app.bridge.pushToFrameSet(event.target.href, event.target.target);
            event.preventDefault();
        }
    },
};

/**
 * @export
 * @param {CIApp} appInstance
 * @return DisclaimerView
 */
export default appInstance => {
    DisclaimerView.$app = appInstance;
    const constObj: any = {};
    DisclaimerView.constants = constObj;
    return DisclaimerView;
};

const initComponent = (options: any) => {
    const appInstance = options.$app;
    const constObj: any = options.constants;
    const config = appInstance.getUIConfig();

    const styleConfig: any = {};
    let disclaimerStyleProps;

    if (config.transcriptConfig) {
        const tConfig = config.transcriptConfig;
        constObj.style = tConfig.disclaimerHeaderViewStyles;
        constObj.imgstyle = tConfig.disclaimerHeaderImageStyles;
        disclaimerStyleProps = tConfig.disclaimerHeaderStyleProperties || {};
        constObj.disImgConfig = tConfig.disclaimerHeaderImageConfig;
    } else {
        disclaimerStyleProps = {};
    }

    styleConfig.marginLeft = `${disclaimerStyleProps.disclaimerLeftMargin || 40}px`;
    styleConfig.marginBottom = `${disclaimerStyleProps.disclaimerBottomMargin || 15}px`;
    styleConfig.marginRight = `${disclaimerStyleProps.disclaimerRightMargin || 40}px`;
    styleConfig.marginTop = `${disclaimerStyleProps.disclaimerTopMargin || 15}px`;

    constObj.disclaimerStyleProps = styleConfig;
    DisclaimerView.constants = constObj;
};
